import { createRouter, createWebHistory, Router, RouteRecordRaw } from 'vue-router'
import Index from '@/views/Index.vue'
import NotFound from '@/views/NotFound.vue'
import { Api } from '@/http/Api'
import { AdminDataResponse, RoutersResponse } from '@/typeDefine/HttpResponseType'
import { DefineComponent } from 'vue'
import AdminIndex from '@/views/Admin/Index.vue'
import AdminLogin from '@/views/Admin/Login.vue'
import { UtilMethods } from '@/util/UtilMethods'
import { ResponseCode } from '@/http/ResponseCode'
import AboutUs from '@/views/AboutUs.vue'
import ContactUs from '@/views/ContactUs.vue'
import NewsList from '@/views/NewsList.vue'
import NewsDetails from '@/views/NewsDetails.vue'
import Product from '@/views/Product.vue'
import ProductDetails from '@/views/ProductDetails.vue'

class AppRoute {
  public static readonly instance: AppRoute = new AppRoute()

  //路由映射
  private static routesMap = {
    Index,
    NotFound,
    AdminIndex,
    AdminLogin
  }

  private router: Router

  private routes = [
    {
      path: '/',
      name: 'index',
      component: Index,
      meta: {
        loginCheck: false
      }
    },

    {
      path: '/:pathMatch(.*)*',
      name: 'notFound',
      component: NotFound,
      meta: {
        loginCheck: false,
      }
    },

    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: AboutUs,
      meta: {
        loginCheck: false,
      }
    },
    {
      path: '/contactUs',
      name: 'contactUs',
      component: ContactUs,
      meta: {
        loginCheck: false,
      }
    },

    {
      path: '/newsList',
      name: 'newsList',
      component: NewsList,
      meta: {
        loginCheck: false,
      }
    },
    {
      path: '/newsDetails/:id',
      name: 'newsDetails',
      component: NewsDetails,
      meta: {
        loginCheck: false,
      }
    },
    {
      path: '/products',
      name: 'products',
      component: Product,
      meta: {
        loginCheck: false,
      }
    },
    {
      path: '/productDetails/:id',
      name: 'productDetails',
      component: ProductDetails,
      meta: {
        loginCheck: false,
      }
    },
  ] as const

  private constructor() {
    this.router = createRouter({
      history: createWebHistory(process.env.BASE_URL),
      routes: this.routes
    })
  }

  //请求完整路由
  private async getRoutersFromServer(): Promise<void> {
    const response: RoutersResponse = await Api.instance.getRouters()

    if (!response) {
      return
    }

    for (const item of response.data.routers) {
      this.router.addRoute({
        path: item.path,
        name: item.name,
        component: AppRoute.routesMap[item.component as keyof typeof AppRoute.routesMap] || NotFound,
        meta: item.meta
      })
    }

  }

  //路由守卫
  private routerGuard(): void {
    this.router.beforeEach(async (to, from, next) => {
      if (!to.meta?.loginCheck) {
        next()
        return
      }

      //登录校验
      const response: AdminDataResponse = await Api.instance.getAdminData()

      UtilMethods.showMessageToast(response, false)

      //未登录进入登录页
      if (response.code !== ResponseCode.OK) {
        next({
          name: 'adminLogin'
        })
        return
      }

      next()
    })
  }

  public get getRouter(): Router {
    return this.router
  }

  public get getRoutes() {
    return this.routes
  }

  public async loadAsync(): Promise<void> {
    await this.getRoutersFromServer()
    this.routerGuard()
  }
}

const routes = AppRoute.instance.getRoutes
const router: Router = AppRoute.instance.getRouter
export { AppRoute, router, routes }
